/* global G */
import asObject from 'lib/sequence/component/children/asObject'
import { hide } from 'lib/sequence/component/state/hidden'
import { settings } from 'app/_shared/session'

/**
 * Shows/hides filter fields according to the {@link supressedTicketFilters} setting.
 *
 * @param {Gaia.AppModule.Spec} module the ticket module composition object
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
export default module => async (children, ...args) => {
  const { filter } = children
  const availableFilters = asObject(filter[G.CHILDREN])

  const { suppressedTicketFilters = [] } = settings

  suppressedTicketFilters.forEach((suppressedFilter) => {
    availableFilters?.[suppressedFilter] && hide(availableFilters[suppressedFilter])
  })

  return [children, ...args]
}
